import React from "react";
import { Box, Menu, MenuItem } from "@mui/material"; 

export function ReasonMenu({ children, reasons, onSelect, loading, style, disabled=false }) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  function handleClick(event) {
    if(disabled) return;
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget);
    }
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const onRejectClick = async (e) => {
    await onSelect(e.target.value);
  }

  return (
    <>
      <Box
        className="reason-menu-wrapper"
        aria-owns={anchorEl ? "simple-menu" : undefined}
        aria-haspopup="true"
        onClick={handleClick}
        sx={style}
      >
        { children }
      </Box>

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{ onMouseLeave: handleClose }}
      >
        {
          (reasons || []).map(
            (dr,i) => <MenuItem key={i} disabled={Boolean(loading)} value={dr.id} onClick={onRejectClick}>{dr.name}</MenuItem>
          )
        }
      </Menu>
    </>
  );
}